<template>
    <button @click.prevent.stop="
                scrollToNextSection();
            " class="scrolltop">
        <img src="images/commons/circle_down.svg" alt="">
    </button>
</template>
<script>
    export default {
        name: "ScrollButton",
        data() {
            return {};
        },
         methods: {
            scrollToNextSection(e) {
                let el = document.querySelector(".q10__first_section > #scrollToNextSection");
                if(el) {
                    $("html,body").animate({ scrollTop: $(el).position().top }, 500, "swing");
                }
            },
            handlerEvents(e) {
                    const vm = this;

                    let section = document.querySelector(".q10__first_section > #scrollToNextSection");
                    if (section){
                        let top = $(e.target).scrollTop();
                        let bottom = top + $(window).innerHeight();
                        if (bottom > $(section).position().top) {
                            bottom = $(section).position().top;
                        }
                        bottom -= 50;
                        $(vm.$el).css({
                            top: bottom
                        });
                    }   
            }
        },
        mounted() {
            const vm = this;
            window.addEventListener("scroll", vm.handlerEvents);
            window.addEventListener("resize", vm.handlerEvents);
            setTimeout(() => {
                vm.handlerEvents({ target: window });
            }, 1000);
        }
    };
</script>

<style lang="scss" scoped>
    .scrolltop {
        bottom: 5%;
        transition: 0.4s;
        animation-name: bounce;
        transform-origin: center;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-duration: 4s;
        animation-delay: 3s;
        animation-fill-mode: both;

       
        z-index: 100;
        position: fixed;
       
        left: 50%;
        transform: translate(-50%);
        
        border-radius: 50%;
        // box-shadow: 0 0 15px hsl(0deg 0% 77% / 61%);
        
        border: none;
        cursor: pointer;

        &:hover {
            animation: none;
        }
        
        img{
            z-index: 1000;
            position: relative;
            transform: rotate(90deg);
            width: 50px;
            height: 50px;
            bottom: 2rem;
        }
    }

// Bounce Animation
    @keyframes bounce {
        0%,
        20%,
        53%,
        to {
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            transform: translateZ(0) translateX(-50%);
        }

        40%,
        43% {
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            transform: translate3d(-50%, -30px, 0) scaleY(1.1);
        }

        70% {
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            transform: translate3d(-50%, -15px, 0) scaleY(1.05);
        }

        80% {
            transform: translateZ(0) translateX(-50%) scaleY(0.95);
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        }

        90% {
            transform: translate3d(-50%, -4px, 0) scaleY(1.02);
        }
    }
</style>
